var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"px-2 py-1 text-back-lightest round-md text-sm bg-opacity-75",class:{
    'bg-status-error': _vm.status === 1,
    'bg-status-warning': _vm.status === 2,
    'bg-status-ok': _vm.status === 3,
  }},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.text, _vm.values))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }